<template>
  <div class="register absolute" style="color: #000;">
    <div class="register_tit">
      <img @click="fanhui" src="../../assets/images/licai/fanhui.png" />
      <p class="">{{ $t("m.jy_span4") }}</p>
    </div>
    <div class="register_block">
      <!-- <div style="width:100%;height: 100px;overflow: hidden;border-radius:6px;">
        <img style="width: 100%;height: auto;" src="../../assets/images/new/tixian.png" alt="">
      </div> -->
      <div
        style="border-radius:8px;background:#fff;padding:15px 15px;margin-top:8px;"
      >
        <div
          style="height: 40px; display:flex;align-items:center;"
          @click="backShow1(0)"
        >
          <img
            src="../../assets/images/yhk.png"
            style="width: 20px;height: 20px;margin-right:10px;"
            alt=""
          />
          <div style="flex:1">
            <p style="font-size:12px;color:#777;">银行卡充值</p>
            <!-- <p style="font-size:15px;color:#000;font-weight:bold;">{{
            list.length > 0 ? list[0].type + " (" + list[0].card + ")" : ""
          }}</p> -->
          </div>
          <!-- <img src="../../assets/images/new/youjiantou.png" style="width: 15px;height: 15px;" alt=""> -->
          <img style="width: 20px;" :src="xuan == 0 ? img1 : img2" />
        </div>
        <div
          style="height: 40px; display:flex;align-items:center;"
          @click="backShow1(1)"
        >
          <img
            src="../../assets/images/new/USDT.png"
            style="width: 20px;height: 20px;margin-right:10px;"
            alt=""
          />
          <div style="flex:1">
            <p style="font-size:12px;color:#777;">USDT充值</p>
            <!-- <p style="font-size:15px;color:#000;font-weight:bold;">{{
            list.length > 0 ? list[0].type + " (" + list[0].card + ")" : ""
          }}</p> -->
          </div>
          <!-- <img src="../../assets/images/new/youjiantou.png" style="width: 15px;height: 15px;" alt=""> -->
          <img style="width: 20px;" :src="xuan == 1 ? img1 : img2" />
        </div>
      </div>
      <div
        style="border-radius:8px;background:#fff;padding:0px 15px;margin-top:8px;"
      >
        <div
          style="border-bottom:1px solid #eee; font-size:26px;font-weight:bold;padding-left:0px;margin-top:0px;line-height:80px;display:flex;align-items:center;"
        >
          <div style="width:60px;font-size:17px;">{{ $t("m.tz_span4") }}</div>
          <div style="flex:1;">
            <input
              readonly="readonly"
              @blur="show1 = false"
              ref="email"
              type="number"
              :placeholder="$t('m.ct_span24')"
              style="margin-left:0px;line-height:80px;width: 100%;flex:1;font-size:20px;"
              v-model="money"
              @click="show1 = true"
            />
          </div>
          <div style="width: 20px;">
            <img
              @click="gg"
              src="../../assets/images/licai/guanbi1.png"
              style="width: 20px;height: 20px;"
              alt=""
            />
          </div>
        </div>
        <div v-if="xuan === 1" class="cz-usdt-rate-hint">
          <p>{{ $t("m.ct_span25", { rate: usdtCnyRateDisplay }) }}</p>
          <p v-if="usdtCnyCredit !== null">
            {{ $t("m.ct_span26", { amount: usdtCnyCredit }) }}
          </p>
        </div>
      </div>
      <div
        style="border-radius:8px;background:#fff;padding:20px 15px;margin-top:8px;padding-bottom:0;"
      >
        <div
          style=" font-size:26px;font-weight:bold;padding-left:0px;margin-top:0px;line-height:40px;display:flex;align-items:center;width: 100%;"
        >
          <div style="display:flex;margin-top:0px;width: 100%;">
            <span
              style="font-size:14px;font-weight:blod;width: 60px;color:#777;"
              >{{ $t("m.jf_span7") }}</span
            >
            <input
              style="border-bottom:1px solid #eee;color:#777; font-size:14px;font-weight:blod;flex:1;line-height:40px;"
              v-model="bz"
              type="text"
              :placeholder="$t('m.hz_span5')"
            />
            <!-- <textarea
            v-model="bz"
            style="flex:1; margin-left:20px;border:1px solid #eee;border-radius:8px;height: 80px;padding-left:0px;"
            placeholder="卡号后4位"
            cols="30"
            rows="10"
          ></textarea> -->
          </div>
        </div>
        <div
          @click="dianjis"
          style="border-radius:8px;background:#fff;padding:0px 0px;margin-top:0px;height: 40px;padding-left:0; display:flex;align-items:center;"
        >
          <!-- <img src="../../assets/images/kefu.png" style="width: 20px;height: 20px;margin-right:10px;" alt=""> -->
          <div style="flex:1">
            <p style="font-size:12px;color:var(--bg-color);">
              {{ $t("m.ct_span2") }}
            </p>
          </div>
          <img
            src="../../assets/images/new/youjiantou.png"
            style="width: 15px;height: 15px;"
            alt=""
          />
        </div>
      </div>

      <div class="register_submit" @click="registerReset">
        {{ $t("m.ct_span22") }}
      </div>
      <!-- <div style="font-size:12px;color:#666;line-height:40px;">{{$t('m.ct_span23')}} <span style="color:#FF3738;">5000000</span> </div> -->
      <!-- <div
        style="font-size:18px;font-weight:blod;text-align:right;overflow: hidden;margin-top:20px;"
      >
        <div
          @click="dianjis"
          style="float:right; font-weight:blod; display:flex;align-items:center;justify-content:center; width: 160px;height: 40px;border-radius:25px;color:#fff;background:#CDA569;font-size:14px;"
        >
          <img
            src="../../assets/images/kf.png"
            style="margin-right:5px; width: 20px;height: 20px;"
            alt=""
            srcset=""
          />
          <span>充值前先联系客服</span>
        </div>
      </div> -->
    </div>

    <div
      v-if="show"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;"
    >
      <div
        style="color:#000; position: absolute;bottom:1rem;left:0;width:100%;height: 60vh;background:#fff;border-radius:5px 5px 0 0;padding:10px;"
      >
        <img
          src="../../assets/images/licai/guanbi2.png"
          @click="guanbi"
          style="width: 20px;height: 20px;"
          alt=""
        />
        <div style="text-align:center;font-size:15px;margin-top:20px;">
          充值
        </div>
        <div
          style="text-align:center;font-size:11px;padding-bottom:30px;border-bottom:1px solid #eee;"
        >
          ¥ <span style="font-size:40px;">{{ money }}</span>
        </div>
        <div
          style="display:flex;align-items:center;font-size:15px;height: 70px;"
        >
          <span style="width: 70px;">付款方式</span>
          <span style="flex:1;flex-direction: row-reverse;display: flex;">{{
            list.length > 0 ? list[0].branch + " (" + list[0].card + ")" : ""
          }}</span>
          <img
            src="../../assets/images/licai/right.png"
            style="width: 20px;height: 20px;margin-left:10px;"
            alt=""
          />
        </div>
        <div
          class="register_submit"
          style="margin-top:35px;"
          @click="register_submit"
        >
          立即付款
        </div>
      </div>
    </div>
    <van-number-keyboard
      :show="show1"
      theme="custom"
      extra-key="."
      close-button-text="完成"
      @blur="show1 = false"
      @input="onInput"
      @delete="onDelete"
    />
    <van-dialog
      confirmButtonColor="#4076FA"
      v-model="passwordShow"
      :title="$t('m.yh_span7')"
      show-cancel-button
      @confirm="pwdChange2"
      @cancel="pwd = ''"
      @close="pwd = ''"
    >
      <div class="zfmm">
        <van-field
          v-model="pwd"
          :placeholder="$t('m.ct_span11')"
          type="password"
        />
      </div>
    </van-dialog>
    <div
      v-if="shows"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { getMyUserInfo } from "@api/user";

import $store from "../../store";
export default {
  name: "CzContent",
  data: function() {
    return {
      passwordShow: false,
      xuan: 0,
      img1: require("../../assets/images/new/xuanzhong.png"),
      img2: require("../../assets/images/new/weixuanzhong.png"),
      show1: false,
      show: false,
      shows: false,
      money: "",
      mima: "",
      dicdata: {},
      list: [],
      bz: "",
      pwd: "",
      bzs: "",
      /** USDT→CNY：与后台 admin_option.usdt_exchange_rate（getUsdCny）一致 */
      usdtCnyRate: null
    };
  },

  computed: {
    usdtCnyRateDisplay() {
      const r = Number(this.usdtCnyRate);
      if (this.usdtCnyRate === null || Number.isNaN(r) || r <= 0) {
        return "--";
      }
      return r;
    },
    usdtCnyCredit() {
      if (this.xuan !== 1) return null;
      const rate = Number(this.usdtCnyRate);
      if (this.usdtCnyRate === null || Number.isNaN(rate) || rate <= 0) {
        return null;
      }
      const raw = String(this.money || "").trim();
      if (raw === "") return null;
      const n = parseFloat(raw);
      if (Number.isNaN(n) || n <= 0) return null;
      return (n * rate).toFixed(2);
    }
  },

  mounted: function() {
    this.$refs.email.focus();
    let that = this;
    request
      .post("/pay/us/cache", {}, { login: true })
      .then(res => {
        const n = parseFloat(res.data.data.usd_cny);
        if (!Number.isNaN(n) && n > 0) {
          that.usdtCnyRate = n;
        }
      })
      .catch(() => {});
    setTimeout(function() {
      getMyUserInfo().then(res => {
        let userInfo = res.data.data;
        if (userInfo.is_auth != 1) {
          //  that.$dialog.message("请先完成实名认证");
          that.$router.push({ name: "memmber_business" });
        }
      });
    }, 500);
    request
      .get("/pay/bank/list", { page: 1 }, { login: true })
      .then(res => {
        this.list = res.data.data;
        console.log(this);
        for (let i = 0; i < this.list.length; i++) {
          const dd = this.list[i].card;
          this.list[i].card = dd.substr(dd.length - 4, 4);
          if (i == 0) {
            this.bzs = this.list[i].card;
          }
        }
      })
      .catch(err => {
        this.$dialog.error(err.response.data.msg);
      });
  },
  methods: {
    pwdChange2() {
      let vm = this;
      vm.passwordShow = false;
      vm.shows = true;
      if (this.xuan == 0) {
        let dic = { money: this.money, remark: this.bz };
        request
          .post("/pay/pay/recharge", dic, { login: true })
          .then(res => {
            this.show = false;
            vm.shows = false;
            this.$dialog.success(res.data.msg);
            let view = $store.state.app.view;
            if (view == "local") {
              this.$router.push({
                path: "/mychat"
              });
            } else {
              this.$router.push({
                path: "/customerService"
                // path: "/mychat"
              });
            }
          })
          .catch(err => {
            vm.shows = false;
            this.$dialog.error(err.response.data.msg);
          });
      } else {
        // window.localStorage.setItem("czje",JSON.stringify(dic))
        //  this.$router.push({
        //     path: "/erweima"
        //   });
        let dic = {
          usdt: this.money,
          remark: this.bz
        };
        request
          .post("/pay/us/recharge", dic, { login: true })
          .then(res => {
            this.show = false;
            vm.shows = false;
            this.$dialog.success(res.data.msg);
            let view = $store.state.app.view;
            if (view == "local") {
              this.$router.push({
                path: "/mychat"
              });
            } else {
              this.$router.push({
                path: "/customerService"
                // path: "/mychat"
              });
            }
          })
          .catch(err => {
            vm.shows = false;
            this.$dialog.error(err.response.data.msg);
          });
      }
    },
    onInput(value) {
      let vm = this;
      this.money = vm.money + value;
    },
    backShow1(E) {
      this.xuan = E;
    },
    onDelete() {
      console.log("sdsdsa");
      this.money = this.money.slice(0, this.money.length - 1);
    },
    fanhui() {
      this.$router.push({
        path: "/"
      });
    },
    gg() {
      this.money = "";
    },
    guanbi() {
      this.show = false;
    },
    dianjis() {
      let view = $store.state.app.view;
      if (view == "local") {
        this.$router.push({
          path: "/mychat"
        });
      } else {
        this.$router.push({
          path: "/customerService"
          // path: "/mychat"
        });
      }
    },
    register_submit() {
      request
        .post(
          "/pay/pay/recharge",
          { money: this.money, remark: this.bz },
          { login: true }
        )
        .then(res => {
          // this.money = "";
          // this.bz = "";
          this.show = false;
          this.$dialog.success(res.data.msg);
          let view = $store.state.app.view;
          if (view == "local") {
            this.$router.push({
              path: "/mychat"
            });
          } else {
            this.$router.push({
              path: "/customerService"
              // path: "/mychat"
            });
          }
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
        });
    },
    registerReset() {
      if (this.money == "" || this.money <= 0) {
        this.$dialog.message("请输入付款金额");
        return;
      }
      if (
        this.xuan === 1 &&
        (this.usdtCnyRate === null ||
          Number.isNaN(Number(this.usdtCnyRate)) ||
          Number(this.usdtCnyRate) <= 0)
      ) {
        this.$dialog.message("汇率加载失败，请下拉刷新或稍后重试");
        return;
      }
      if (this.xuan === 1 && this.usdtCnyCredit === null) {
        this.$dialog.message("请输入付款金额");
        return;
      }
      if (this.xuan === 1 && parseFloat(this.usdtCnyCredit) < 100) {
        this.$dialog.message("换算后金额需满100元");
        return;
      }
      // this.passwordShow = true;

      this.pwdChange2();
      // this.show = true;
    }
  }
};
</script>
<style scoped lang="less">
/deep/.zfmm {
  padding: 10px;
  padding-bottom: 20px;
  width: 100%;
  text-align: center;
  color: #333333;
  padding-left: 20px;
  padding-right: 20px;

  .van-field {
    background-color: #f1f1f3;
    background-color: #f1f1f3;
  }
}
/deep/ .van-key--blue {
  background: var(--bg-color);
}
.register_submit {
  margin: 0 auto;
  height: 50px;
  background: var(--bg-color);
  border-radius: 5px;
  margin-top: 25px;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-size: 16px;
  border-radius: 30px;
}

.cz-usdt-rate-hint {
  padding: 0 0 14px;
  font-size: 13px;
  line-height: 1.55;
  color: #666;
  p {
    margin: 4px 0 0;
  }
}

.register_block {
  padding: 10px;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 15px;
}
.register_code_lists {
  border: 1px solid #CDA569;
  text-align: center;
  color: #CDA569;
  border-radius: 6px;
  width: 36%;
  height: 45px;
  margin-left: 15px;
  line-height: 45px;
}
.register_code_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.register_code {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
</style>
